import { ZoomGridHero } from "@/components/home/ZoomGridHero";
import { HomeSections } from "@/components/home/HomeSections";
import { SEO, PAGE_SEO } from "@/components/SEO";

export default function Home() {
  return (
    <>
      <SEO {...PAGE_SEO.home} />
      <ZoomGridHero />
      <HomeSections />
    </>
  );
}
